export default __webpack_public_path__ + "static/media/bkg--location-2.0296c526.jpg";